enum AttachedCommunicationType {
    Task,
    Message,
    Recall
}

export { AttachedCommunicationType };
